import { fetchPaginatedUsers } from '#action/user/users-paginated';
import { ProjectsFilterOptionService } from '#service/autocomplete-service/service';
import { FilterOption } from '#service/autocomplete-service/option';
import { uuidv4 } from '#helper';

const userExpiredOptions = [
  { label: 'All users', value: '0', id: '0' },
  { label: 'Active only', value: '1', id: '1' }
];

const searchProps = {
  type: 'Search',
  name: 'search',
  label: 'Search a user',
  relatedTo: 'user',
  id: uuidv4()
};

const projectComponent = {
  type: 'MultipleSelect',
  name: 'project',
  label: 'Project',
  relatedTo: 'user',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const userExpiredComponent = {
  type: 'RadioButtonsGroup',
  name: 'unexpired',
  label: 'Status',
  relatedTo: 'user',
  id: uuidv4(),
  options: userExpiredOptions.map(o => new FilterOption(o, o.label))
};

const filterConfig = {
  customActions: {
    fetchFilterData: fetchPaginatedUsers
  },
  searchProps,
  components: [projectComponent, userExpiredComponent]
};

export default filterConfig;
